import React, { useEffect, useState } from 'react';
import { BadgeCheck } from 'lucide-react';
import { authAPI, api } from '../services/api';
import { useT } from '../services/i18n';

let cached = null;
const loadPro = async () => {
  if (cached) return cached;
  if (!authAPI.isAuthenticated()) return { is_pro: false, vat_rate: 20 };
  const [profile, company] = await Promise.all([authAPI.getProfile().catch(() => ({})), api.get('/company').then(r => r.data).catch(() => ({}))]);
  cached = { is_pro: !!profile.is_pro, vat_rate: company.vat_rate ?? 20, pct: Number(profile.pro_discount_pct || 0) };
  return cached;
};

// Shows the HT price next to a TTC price for validated professional accounts
const ProPriceHint = ({ price, className = '' }) => {
  const { t } = useT();
  const [info, setInfo] = useState(null);
  useEffect(() => { loadPro().then(setInfo); }, []);
  if (!info?.is_pro || !price) return null;
  return (
    <span className={`inline-flex flex-col text-sm text-[#1e3a5f] font-medium ${className}`} data-testid="pro-price-ht">
      <span className="inline-flex items-center gap-1"><BadgeCheck size={14} className="text-orange-500" /> {t('pro.ht', { price: (price / (1 + info.vat_rate / 100)).toFixed(2) })}</span>
      {info.pct > 0 && <span className="text-xs text-green-700 font-semibold" data-testid="pro-price-discount">{t('pro.discount', { pct: info.pct, price: (price * (1 - info.pct / 100)).toFixed(2) })}</span>}
    </span>
  );
};

export default ProPriceHint;
